export class Structured {
  public _id: string
  public id: string
  public parent: string
  public directory: boolean
  public name: string
  public originalname: string
  public folderId: string
  public path: string
  public type: string
  public subType: string
  public thumbnailPath: string
  public mime: string
  public extension: string
  public createdAt: string
  public updatedAt: string

  /* "_id": {
    "$oid": "5d4177da482acb0082c4ec09"
  },
  "name": "5529814737_433ebb1661_z.jpg",
  "originalname": "5529814737_433ebb1661_z.jpg",
  "folderId": "2d5dfee",
  "parent": {
    "$oid": "5d41760995d64e002eb483e9"
  },
  "type": "CONTENT",
  "subtype": "FILE",
  "creator": "admin",
  "createdAt": {
    "$date": "2019-07-31T11:13:28.768Z"
  },
  "updatedAt": {
    "$date": "2019-07-31T11:13:28.768Z"
  },
  "thumbnailPath": "/thumbnails/2d5dfee096.thumbnail",
  "extension": "jpg",
  "mime": "image/jpg" */
}
